import { CloudTeams } from 'js/common/utils/bugsnag';

export const PAYMENT_PAGE_BUGSNAG_TEAM = CloudTeams.Payments;
